import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { changePlanColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getChangePlan } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "plan_id",
  "plan",
  "trial_count",
  "last_updated",
];

const ChangePlanBatch = () => (
  <BatchDetail
    title="Plan Change"
    apiGet={__getChangePlan}
    client={CLIENTS.ultra}
    columnsFactory={changePlanColumns}
    copyKeys={COPY_KEYS}
    exportAction="change_plan"
    retryOperation="change_plan"
    showTerminate
    getRowPath={(row) => `/ultra/change_plan/${row.id}`}
  />
);


export default ChangePlanBatch;
